module.exports = __webpack_public_path__ + "img/help15.db5a5f9e.png";